module.exports = __webpack_public_path__ + "img/011钜宝、恒基代表.cba821b8.png";